import PromotionManagementTemplate from "../../../templates/admin/promotionManagement";

const PromotionManagementScreen = () => {
  return <PromotionManagementTemplate />;
};

export default PromotionManagementScreen;
